import { AxiosError } from 'axios';
import { ChangeEvent, forwardRef, useImperativeHandle, useState } from 'react';
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axiosInstance from 'utils/axiosInterceptors';
import { toastConfig } from 'utils/toastConfig';

export type UploadPurchaseOrderListImageFormHandle = {
  submit: () => Promise<boolean | undefined>;
};

type UploadPurchaseOrderListImageFormProps = {
  branchDomain: string | undefined;
  purchaseOrderId: string | undefined;
};

const UploadPurchaseOrderListImageForm = forwardRef<
  UploadPurchaseOrderListImageFormHandle,
  UploadPurchaseOrderListImageFormProps
>(({ branchDomain, purchaseOrderId }, ref) => {
  const [images, setImages] = useState<FileList | null>(null);

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    setImages(e.target.files);
  };

  const handleSubmit = async () => {
    try {
      if (!images || images.length === 0) {
        toast.error('No image selected', { ...toastConfig, autoClose: 3000 });
        return false;
      }

      const formData = new FormData();
      Array.from(images).forEach(file => formData.append('files', file));
      await axiosInstance.post(
        `/api/v1/${branchDomain}/purchaseOrders/${purchaseOrderId}/images`,
        formData
      );
      toast.success('List photo uploaded. Extracting items…', {
        ...toastConfig,
        autoClose: 3000
      });

      return true;
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data.errorMessage, {
          ...toastConfig,
          autoClose: 3000
        });
      }
      return false;
    }
  };

  useImperativeHandle(ref, () => ({
    submit: handleSubmit
  }));

  return (
    <Form className="w-100">
      <Form.Label>Upload list photo</Form.Label>
      <Form.Control
        type="file"
        multiple
        accept="image/*,application/pdf"
        onChange={handleFileChange}
      />
      <Form.Text className="text-body-tertiary">
        Photo of a handwritten or typed parts list. Items will be extracted and
        matched automatically.
      </Form.Text>
    </Form>
  );
});

export default UploadPurchaseOrderListImageForm;
